import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
;
const SvgInfoRound = _ref => {
  let {
    primaryColor,
    colorMapping,
    ...props
  } = _ref;
  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const randomizedId = getRandomInt(1, 1000);
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    "data-component": "SvgInfoRound"
  }), React.createElement("g", {
    clipPath: `url(#${randomizedId})`
  }, React.createElement("path", {
    stroke: primaryColor,
    strokeWidth: 1.5,
    d: "M10 10.5h2v7m-2 0h4M12.5 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: randomizedId
  }, React.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
SvgInfoRound.__name = 'SvgInfoRoundinfo_round';
;
export default SvgInfoRound;